import { Component, OnInit } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { DashboardService } from "app/dashboard/dashboard.service";
import { ConfigurationService } from "app/masters/configuration/configuration.service";
import { OpdVisitService } from "app/opdvisits/Services/OpdVisit.service";
import { BillingserviceService } from "../billingService.service";
import { EmailIpdFilesComponent } from "./email-ipd-files/email-ipd-files.component";
import { PatientFilesComponent } from "./patient-files/patient-files.component";

@Component({
  selector: "app-email-to-party",
  templateUrl: "./email-to-party.component.html",
  styleUrls: ["./email-to-party.component.scss"],
})
export class EmailToPartyComponent implements OnInit {
  patSelectfiles: any = [];
  IpdSelectFiles: any = [];
  emailData: any;
  subject: any;
  msgeTemp: any;
  emailcc: any;
  sendToEmail: string = "";
  attachment: any = [];
  selectedFile: any = [];
  filename: any = [];
  documentrul = [];
  mainUrl: any;
  patRegId: number;
  message: string;
  patDocAttachment = [];
  patIPDAttachment = [];
  patIpdId: any;
  showspinner: boolean = false;

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<EmailToPartyComponent>,
    public billingService: BillingserviceService,
    public snackBar: MatSnackBar,
    public dashboardService: DashboardService,
    public opdvisitService: OpdVisitService
  ) {}

  ngOnInit(): void {
    this.allEmailType();
    this.documentURL();
    this.patRegId = this.opdvisitService.patientdetails.pkRegId;
    this.patIpdId = this.opdvisitService.ipdId;
    this.billingService.patientdata = [];
    this.billingService.ipdDocdata = [];
  }

  allEmailType() {
    this.billingService.getAllEmailConfig().subscribe((data) => {
      let selecttype = data;
      this.emailData = selecttype.filter(
        (item) => item.emailType == "CORPORATE DETAIL"
      );
      this.subject = this.emailData[0].subject;
      this.msgeTemp = this.emailData[0].messageTemplate;
      this.emailcc = this.emailData[0].emailCC;
    });
  }
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }
  closedialog() {
    this.dialogRef.close();
  }
  /* Email to Party popup */
  emailIpdFiles() {
    const dialogRef1 = this.dialog.open(EmailIpdFilesComponent, {
      // panelClass: "full-width-dialog",
      // maxWidth: "100vw !important",
      height: "60%",
      width: "75%",
    });

    dialogRef1.afterClosed().subscribe((result) => {
      this.patIPDAttachment = [];
      this.IpdSelectFiles = this.billingService.ipdDocdata;
      this.IpdSelectFiles.forEach((element) => {
        // let imageUrl = this.mainUrl + 'IPDDocument/' + this.patIpdId + '/' + element;
        let imageUrl = element.fileurl;
        this.patIPDAttachment.push(
          "<p><a href=" + imageUrl + ">" + element.filename + " </a></p> "
        );
      });
    });
  }
  /* Email to Party popup */
  emailPatientFiles() {
    const dialogRef1 = this.dialog.open(PatientFilesComponent, {
      // panelClass: "full-width-dialog",
      // maxWidth: "100vw !important",
      height: "60%",
      width: "75%",
    });

    dialogRef1.afterClosed().subscribe((result) => {
      this.patDocAttachment = [];
      this.patSelectfiles = this.billingService.patientdata;
      this.patSelectfiles.forEach((element) => {
        // let eleUrl = this.mainUrl + 'PatientDocuments/' + this.patRegId + '/' + element;
        let eleUrl = element.fileurl;
        this.patDocAttachment.push(
          "<p><a href=" + eleUrl + ">" + element.filename + " </a></p> "
        );
      });
    });
  }
  browseFile(event) {
    let file = event.target.files;
    for (var i = 0; i < file.length; i++) {
      this.selectedFile.push(file[i]);
    }
  }

  sendEmailtoParty() {
    if (this.sendToEmail == "") {
      this.openSnackBar("Please Enter ToEmail", "Ok");
      return;
    }
    this.showspinner = true;
    let attachfile =
      this.msgeTemp +
      this.patDocAttachment.join(" ") +
      this.patIPDAttachment.join(" ");
    // console.log(attachfile);
    const formData = new FormData();
    this.selectedFile.forEach((item) => {
      formData.append("file[]", item);
    });
    formData.append("EmailCC", this.emailcc);
    formData.append("SubjectCustom", this.subject);
    formData.append("EmailType", "CORPORATE DETAIL");
    formData.append("ToEmail", this.sendToEmail);
    formData.append("MessageTemplateCustom", attachfile);
    this.billingService.sendEmail(formData).subscribe((data) => {
      this.showspinner = false;
      this.openSnackBar(data.message, "Ok");
      this.closedialog();
    });
  }

  documentURL() {
    this.dashboardService.getdocument_url().subscribe(
      (data) => this.success_docurl(data),
      (err) => this.failed_docurl(err)
    );
  }
  success_docurl(data) {
    this.documentrul = data;
    var urldoc = this.documentrul.filter(
      (item) => item.propertyName == "MainImagePathWebNetram"
    );
    this.mainUrl = urldoc[0]?.propertyValue;
  }
  failed_docurl(err) {}
}
